import { render, staticRenderFns } from "./NavTabsCard.vue?vue&type=template&id=17d152a5&"
import script from "./NavTabsCard.vue?vue&type=script&lang=js&"
export * from "./NavTabsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d152a5')) {
      api.createRecord('17d152a5', component.options)
    } else {
      api.reload('17d152a5', component.options)
    }
    module.hot.accept("./NavTabsCard.vue?vue&type=template&id=17d152a5&", function () {
      api.rerender('17d152a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cards/NavTabsCard.vue"
export default component.exports